import { createSlice } from "@reduxjs/toolkit";
import { FetchStatusType } from "@core/modeles/model.ts";
import { RootState } from "@core/store/store.ts";
import { InterimAgentDTO } from "@modules/setting/userManagement/interimAgent/interimAgent.model.ts";
import { PaginateResponse } from "@utils/appUtils.ts";
import {
  createInterimAgent,
  getAllInterimAgents,
  returnInterimAgent,
} from "@core/actions/interimAgentAction.ts";

interface InterimAgentState {
  loadingCreate: FetchStatusType;
  loadingList: FetchStatusType;
  loadingReturn: FetchStatusType;
  interimAgentResponse: PaginateResponse<InterimAgentDTO> | null;
}

const initialState: InterimAgentState = {
  loadingCreate: FetchStatusType.IDLE,
  loadingList: FetchStatusType.IDLE,
  loadingReturn: FetchStatusType.IDLE,
  interimAgentResponse: null,
};

const InterimAgentSlice = createSlice({
  name: "interimAgent",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    /* ---------- Create ---------- */
    builder.addCase(createInterimAgent.pending, (state) => {
      state.loadingCreate = FetchStatusType.LOADING;
    });
    builder.addCase(createInterimAgent.fulfilled, (state) => {
      state.loadingCreate = FetchStatusType.COMPLETED;
    });
    builder.addCase(createInterimAgent.rejected, (state) => {
      state.loadingCreate = FetchStatusType.FAILED;
    });

    /* ---------- List ---------- */
    builder.addCase(getAllInterimAgents.pending, (state) => {
      state.loadingList = FetchStatusType.LOADING;
    });
    builder.addCase(getAllInterimAgents.fulfilled, (state, action) => {
      state.loadingList = FetchStatusType.COMPLETED;
      if (action.payload) {
        state.interimAgentResponse = action.payload;
      }
    });
    builder.addCase(getAllInterimAgents.rejected, (state) => {
      state.loadingList = FetchStatusType.FAILED;
    });

    /* ---------- Return ---------- */
    builder.addCase(returnInterimAgent.pending, (state) => {
      state.loadingReturn = FetchStatusType.LOADING;
    });
    builder.addCase(returnInterimAgent.fulfilled, (state) => {
      state.loadingReturn = FetchStatusType.COMPLETED;
    });
    builder.addCase(returnInterimAgent.rejected, (state) => {
      state.loadingReturn = FetchStatusType.FAILED;
    });
  },
});

export default InterimAgentSlice.reducer;

/* Selectors */
export const interimAgentList = (state: RootState) =>
  state.interimAgent.interimAgentResponse;
export const loadingCreateInterim = (state: RootState) =>
  state.interimAgent.loadingCreate;
export const loadingListInterim = (state: RootState) =>
  state.interimAgent.loadingList;
export const loadingReturnInterim = (state: RootState) =>
  state.interimAgent.loadingReturn;
